<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.name }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              type="primary"
              @click="$router.push('/tools/events/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <span class="d-lg-block d-none ml-1">Event</span>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search by name, code or description..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div class="box-buttons">
              <base-button
                type="outline-neutral"
                class="min-button"
                v-if="activeFilter"
                @click="resetSearchFilter()"
              >
                <i class="flaticon-eraser"></i>
                <span class="d-lg-block d-none ml-1">Reset Search</span>
              </base-button>

              <base-dropdown
                menu-on-right
                class="nav-item"
                tag="li"
                title-tag="a"
                title-classes="btn min-button btn-outline-neutral "
                title="Status"
              >
                <base-button slot="title" type="none" class="p-0 min-button">
                  <i class="flaticon-rec"></i>
                  <strong class="d-lg-block d-none ml-1">Status</strong>
                </base-button>
                <div
                  class="dropdown-item"
                  v-for="filter in statusFilters"
                  :class="filters.status === filter.value ? 'active' : ''"
                  :key="filter.value"
                  @click="applyFilterByStatus(filter.value)"
                >
                  <i :class="filter.icon"></i>
                  {{ filter.label }}
                </div>
              </base-dropdown>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div
                class="col-12 pt-0 pb-3 text-right"
                v-if="activeFilter || sortBy"
              >
                <template v-if="activeFilter">
                  <span><strong>Filtered by: </strong></span>
                  <ul class="box-tags-filters">
                    <li class="tags-filters" v-if="filters.status">
                      Status: {{ formatEventStatus(filters.status) }}
                    </li>
                    <li class="tags-filters" v-if="simpleSearch">
                      {{ simpleSearch }}
                    </li>
                    <li class="d-inline-block">
                      <span @click="resetSearchFilter()" class="curp"
                        ><i class="flaticon-cancel ml-2"></i
                      ></span>
                    </li>
                  </ul>
                </template>
                <template v-if="sortBy">
                  <span class="ml-3"><strong>Sorted by:</strong></span>
                  <ul class="box-tags-filters">
                    <li class="tags-filters">
                      {{ getSortName(sortBy, sortType) }}
                    </li>
                    <li class="d-inline-block">
                      <span @click="resetSortAction()" class="curp"
                        ><i class="flaticon-cancel ml-2"></i
                      ></span>
                    </li>
                  </ul>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12 ml-auto text-right"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0 mb-1"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-0"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySort"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortType"
                    :disabled="!sortBy"
                    @change="applySort"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="events.pages"
          :total="events.count"
          v-model="currentPage"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="getEvents"
          @nextPage="getEvents"
          @prevPage="getEvents"
          position="bottom"
        />
        <b-table
          hover
          :items="events.docs"
          :fields="headers"
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
        >
          <template #cell(name)="data">
            <router-link
              :to="`/tools/events/${data.item._id}`"
              class="title multiline-3"
            >
              <span class="username hide-data">{{ data.item.name }}</span>
            </router-link>
          </template>

          <template #cell(code)="data">
            <span class="hide-data">{{ data.item.code }}</span>
          </template>

          <template #cell(dates)="data">
            <span class="hide-data">{{ formatEventDates(data.item) }}</span>
          </template>

          <template #cell(timezone)="data">
            <span class="hide-data">{{ data.item.timezone || "-" }}</span>
          </template>

          <template #cell(customer)="data">
            <span class="hide-data">{{
              getEventCustomerName(data.item.customer)
            }}</span>
          </template>

          <template #cell(status)="data">
            <div
              class="capitalize badge-status"
              v-bind:class="getEventStatusClass(data.item.status)"
            >
              {{ formatEventStatus(data.item.status) }}
            </div>
          </template>

          <template #cell(actions)="data">
            <el-tooltip content="View Event" placement="bottom">
              <router-link
                class="icon-action text-info"
                :to="`/tools/events/${data.item._id}`"
              >
                <i class="flaticon-visualization text-primary"></i>
              </router-link>
            </el-tooltip>

            <el-tooltip
              :content="
                isActive(data.item) ? 'Mark as Inactive' : 'Mark as Active'
              "
              placement="bottom"
            >
              <span
                class="icon-action text-info ml-2"
                @click.stop="changeStatus(data.item)"
              >
                <i class="flaticon-right-4"></i>
              </span>
            </el-tooltip>
          </template>
        </b-table>

        <pagination-block
          :pageCount="events.pages"
          :total="events.count"
          v-model="currentPage"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="getEvents"
          @nextPage="getEvents"
          @prevPage="getEvents"
          position="bottom"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Swal from "sweetalert2";
import { EventsAPI } from "@/core/api";
import { goBack, setSigOut } from "@/helpers/commons.helpers";
import {
  EVENT_STATUS,
  EVENT_STATUS_FILTERS,
  EVENT_SORT_OPTIONS,
  EVENT_TABLE_HEADERS
} from "../constants/events.constants";
import {
  formatEventDates,
  formatEventStatus,
  getEventStatusClass,
  getEventCustomerName
} from "../services/event-format.service";
import { getEventErrorMessage } from "../services/event-error.service";

const ERROR_MESSAGE = "The Operation couldn't be completed. Please try again";

export default {
  name: "Events",
  data() {
    return {
      events: { docs: [], count: 0, pages: 0 },
      headers: EVENT_TABLE_HEADERS,
      statusFilters: EVENT_STATUS_FILTERS,
      sortOptions: EVENT_SORT_OPTIONS,
      currentPage: 1,
      limit: 15,
      simpleSearch: "",
      filters: { status: "" },
      sortBy: "",
      sortType: "asc",
      timeoutId: null
    };
  },
  computed: {
    activeFilter() {
      return !!(this.simpleSearch || this.filters.status);
    },
    // Query string the events endpoint receives besides limit and page.
    query() {
      const params = new URLSearchParams();
      if (this.simpleSearch) params.append("search", this.simpleSearch);
      if (this.filters.status) params.append("status", this.filters.status);
      if (this.sortBy) {
        params.append("sortBy", this.sortBy);
        params.append("sortType", this.sortType);
      }
      return params.toString();
    },
    ...mapGetters(["sesion", "paginationLimit"])
  },
  mounted() {
    this.setItemsBread([
      { text: "Dashboard", to: "/dashboard" },
      { text: "Tools", to: "/tools" },
      { text: "Events", active: true }
    ]);
  },
  async created() {
    await this.getLimit();
    this.limit = this.paginationLimit || this.limit;
    this.getEvents(1);
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    formatEventDates,
    formatEventStatus,
    getEventStatusClass,
    getEventCustomerName,
    isActive(event) {
      return event.status !== EVENT_STATUS.INACTIVE;
    },
    async getEvents(page = this.currentPage) {
      try {
        this.setLoad(true);
        const { data } = await EventsAPI.getEvents(
          this.limit,
          page,
          this.query,
          this.sesion.token
        );
        this.events = data;
        this.currentPage = page;
      } catch (error) {
        this.handleError(error, ERROR_MESSAGE);
      } finally {
        this.setLoad(false);
      }
    },
    changeLimit(limit) {
      if (this.limit === limit) return;
      this.limit = limit;
      this.getEvents(1);
    },
    applySimpleSearch() {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => this.getEvents(1), 500);
    },
    applyFilterByStatus(status) {
      this.filters.status = status;
      this.getEvents(1);
    },
    applySort() {
      this.getEvents(1);
    },
    resetSearchFilter() {
      this.simpleSearch = "";
      this.filters.status = "";
      this.getEvents(1);
    },
    resetSortAction() {
      this.sortBy = "";
      this.sortType = "asc";
      this.getEvents(1);
    },
    getSortName(sortBy, sortType) {
      const option = this.sortOptions.find(option => option.value === sortBy);
      return option ? `${option.text} - ${sortType.toUpperCase()}` : "";
    },
    async changeStatus(event) {
      const status = this.isActive(event)
        ? EVENT_STATUS.INACTIVE
        : EVENT_STATUS.ACTIVE;
      const { value } = await Swal.fire({
        title: "Change Status",
        html: `Do you want to mark the event <strong>${
          event.code
        }</strong> as ${formatEventStatus(status)}?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        cancelButtonClass: "btn btn-secondary btn-small-one",
        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      });
      if (value) await this.updateEventStatus(event._id, status);
    },
    async updateEventStatus(eventId, status) {
      try {
        this.setLoad(true);
        await EventsAPI.updateEventById(eventId, { status }, this.sesion.token);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Event status has been changed",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.handleError(error, ERROR_MESSAGE);
      } finally {
        this.setLoad(false);
        this.getEvents();
      }
    },
    handleError(error, message) {
      if (error.response && error.response.data.code === 401) {
        if (setSigOut(error)) this.setSigOut(true);
        return;
      }
      this.$notify({
        type: "danger",
        title: "Error!",
        message: getEventErrorMessage(error, message),
        icon: "flaticon-remove"
      });
    },
    goToPreviousPage() {
      goBack(this);
    },
    ...mapMutations(["setSigOut", "setLoad", "setItemsBread"]),
    ...mapActions(["getLimit"])
  }
};
</script>
